import { AlertCircle, RefreshCw } from "lucide-react";
import { Navigate, Route, Routes } from "react-router-dom";

import { ColocaButton } from "@/shared/components/buttons/ColocaButton";
import { ColocaAlert } from "@/shared/components/feedback/ColocaAlert";
import { ColocaSkeleton } from "@/shared/components/feedback/ColocaSkeleton";
import useTranslations from "@/shared/lang/useTranslations";

import { INTERNAL_API_KEYS_PATH } from "./constants/internalApiKeys.constants";
import { useInternalApiKeyAccess } from "./hooks/useInternalApiKeyAccess";
import InternalApiKeysPage from "./pages/InternalApiKeysPage";

// The registry's `enabled` flag only hides the menu entry, so the route closes itself too for staff off the
// allowlist. The backend refuses them regardless.
export const InternalApiKeysNavigation = () => {
  const { t } = useTranslations("internalApiKeys");
  const { allowed, isLoading, failed, retry } = useInternalApiKeyAccess();
  if (isLoading) return <ColocaSkeleton className="m-2 h-40 w-full max-w-[1100px] rounded-2xl" />;
  // A failed read is not a "no": bouncing would lose a direct link over a blip.
  if (failed) {
    return (
      <ColocaAlert
        className="m-2 max-w-[1100px]"
        variant="destructive"
        icon={AlertCircle}
        text={t("access_failed")}
        actions={
          <ColocaButton variant="default" size="sm" icon={RefreshCw} onClick={retry}>
            {t("action_retry")}
          </ColocaButton>
        }
      />
    );
  }
  if (!allowed) return <Navigate to="/app/wallets" replace />;
  return (
    <Routes>
      <Route index element={<InternalApiKeysPage />} />
      <Route path="*" element={<Navigate to={INTERNAL_API_KEYS_PATH} replace />} />
    </Routes>
  );
};
